/* eslint-disable react/display-name */
import * as React from 'react';
var InfoCircleFilled = React.forwardRef(function (_a, ref) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, ref: ref, viewBox: "0 0 24 24" },
        React.createElement("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm.25 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75c0 .138.112.25.25.25h.75a1 1 0 010 2z" })));
});
export default InfoCircleFilled;
//# sourceMappingURL=InfoCircleFilled.js.map